
// import { Skeleton } from './Settings';
// import { formatTimestampToDate } from './Utils';
import Request from './request';
export const getOrders = async (params, start, limit) => {
  const requestParams = {
    ...params,
    sort: {
      // 'ranking' : -1,
      'id'      : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };

  // 判断 requestParams 里是否存在 filter，且 filter 下的 affiliateid 为空字符串
  if (requestParams.filter && requestParams.filter.affiliateid === "") {
    requestParams.filter.affiliateid = null;
  }

  console.log('requestParams', requestParams);
  return await Request.get('/v1/orders', requestParams).then((res) => {
    return res;
  });
};

export const getOrder = async (id) => {
  return await Request.get('/v1/orders/' + id).then((res) => {
    return res;
  });
}; 

export const postOrder = async (params) => {
  return await Request.formpost('/v1/orders', params).then((res) => {
    return res;
  });
};

export const putOrderCancel = async (orderid) => {
  return await Request.put('/v1/orders/'+orderid+'/cancel', {}).then((res) => {
    return res;
  });  
};

export const putOrderInvalid = async (orderid) => {
  return await Request.put('/v1/orders/'+orderid+'/invalid', {}).then((res) => {
    return res;
  });
};

export const getPayments = async (orderid) => {
  return await Request.get('/v1/orders/' +orderid+ '/paychannels').then((res) => {
    return res;
  });
};

export const putOrderTransaction = async (orderid, dealamount, adminmemo, params) => {
  params.dealamount = dealamount;
  params.adminremark  = adminmemo;
  return await Request.put('/v1/orders/'+orderid+'/transaction', params).then((res) => {
    return res;
  });  
};


export const putOrderBasicinfo = async (orderid, params) => {
  return await Request.put('/v1/orders/'+orderid+'/basicinfo', params).then((res) => {
    return res;
  });  
};

export const getOrderItems = async (orderid) => {
  return await Request.get('/v1/orders/' +orderid+ '/items').then((res) => {
    return res;
  });
};

export const postOrderItems = async (orderid, params) => {
  return await Request.formpost('/v1/orders/' +orderid+ '/items', params).then((res) => {
    return res;
  });
};

export const postOrderCharge = async (orderid, params) => {
  return await Request.formpost('/v1/orders/' +orderid+ '/charges', params).then((res) => {
    return res;
  });
};

export const getOrderCharges = async (orderid) => {
  const params = {
    'sort' : {
      'id' : 'DESC'
    }
  };
  return await Request.get('/v1/orders/' +orderid+ '/charges', params).then((res) => {
    return res;
  });
};

export const getOrderChargeTransaction = async (orderid, chargeid) => {
  let params = {};
  return await Request.get('/v1/orders/' +orderid+ '/charges/' + chargeid + '/transaction', params).then((res) => {
    return res;
  });
};

export const deleteBadge = async (orderid, itemid, badgeid) => {
  let params = {
    badgeid: badgeid,
  };
  return await Request.delete('/v1/orders/'+orderid+'/items/'+itemid, params).then((res) => {
      return res;
  });
}

export const checkBadge = async (eventid, badgeid) => {
  let params = {
    multiple: true,
  };
  return await Request.formpost('/v1/events/'+eventid+'/badges/'+badgeid+'/checklogs', params).then((res) => {
    return res;
  });
}

export const getOrderInvoices = async (orderid) => {
  return await Request.get('/v1/orders/' +orderid+ '/invoices').then((res) => {
    return res;
  });
};

export const putOrderInvoices = async (orderid, invoiceid, params) => {
  return await Request.put('/v1/orders/' +orderid+ '/invoices/'+ invoiceid,params).then((res) => {
    return res;
  });
};

export const putOrderInvoicesAccept = async (orderid, invoiceid, params) => {
  return await Request.put('/v1/orders/' +orderid+ '/invoices/'+ invoiceid + '/accept',params).then((res) => {
    return res;
  });
};

export const postOrderInvoices = async (orderid, params) => {
  return await Request.formpost('/v1/orders/' +orderid+ '/invoices', params).then((res) => {
    return res;
  });
}

export const postOrderPaidproof = async (orderid, chargeid, fileProof, params) => {
  return await Request.fileformpost('/v1/orders/' +orderid+ '/charges/'+chargeid+'/proof', 'fileproof', fileProof, params).then((res) => {
    return res;
  });
}

export const putOrderConfirm = async (orderid, chargeid, params) => {
  return await Request.put('/v1/orders/' +orderid + '/charges/' + chargeid + '/confirm', params).then((res) => {
    return res;
  });
}

export const putOrderPaid = async (orderid, params) => {
  return await Request.put('/v1/orders/' +orderid+ '/paid', params).then((res) => {
    return res;
  });
}

export const postOrderRefunds = async (orderid) => {
  const params = {};
  return await Request.formpost('/v1/orders/' +orderid+ '/refunds', params).then((res) => {
    return res;
  });
}

//put /v1/orders/{orderid}/refunds/{chargeid}/accept`
export const putOrderRefundsAccept = async (orderid, chargeid, params) => {
  return await Request.put('/v1/orders/' +orderid+ '/refunds/'+ chargeid + '/accept', params).then((res) => {
    return res;
  });
}

export const postOrderRefundProof = async (orderid, chargeid, fileProof, params) => {
  return await Request.fileformpost('/v1/orders/' +orderid+ '/refunds/'+chargeid+'/proof', 'fileproof', fileProof, params).then((res) => {
    return res;
  });
}

//put /v1/orders/{orderid}/refunds/{chargeid}/confirm
export const putOrderRefundConfirm = async (orderid, chargeid, params) => {
  console.log('put order refund:', params);
  return await Request.put('/v1/orders/' +orderid+ '/refunds/'+ chargeid + '/confirm', params).then((res) => {
    return res;
  });
}

export const getOrderRefunds = async (orderid) => {
  const params = {
    'sort' : {
      'id' : 'DESC'
    }
  };
  return await Request.get('/v1/orders/' +orderid+ '/refunds', params).then((res) => {
    return res;
  });
};

export const postCharge = async (params) => {
  console.log('postCharge params', params);
  return await Request.formpost('/v1/payment/charges', params).then((res) => {
    return res;
  });
};

export const getPaymentCharges = async (params) => {
  return await Request.get('/v1/payment/charges', params).then((res) => {
    return res;
  });
};